import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoAplicacaoItemModel, ConsultaSeguimentoOutroFieldModel } from '../../model-consultaSeguimento'

export enum ConsultaSeguimentoPergunta15TentaImitarEnum {
  POE_LINGUA_PRA_FORA = 'POE_LINGUA_PRA_FORA',
  FAZ_SOM_ENGRACADO = 'FAZ_SOM_ENGRACADO',
  DA_TCHAU = 'DA_TCHAU',
  BATE_PALMAS = 'BATE_PALMAS',
  COLOCA_DEDOS_NOS_LABIOS = 'COLOCA_DEDOS_NOS_LABIOS',
  MANDA_BEIJO = 'MANDA_BEIJO',
}

export interface ConsultaSeguimentoPergunta15Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_15_HEADER?: SimNaoEnum
  PERGUNTA_15_TENTA_IMITAR?: Record<ConsultaSeguimentoPergunta15TentaImitarEnum, SimNaoEnum>
  OUTRO?: ConsultaSeguimentoOutroFieldModel
}
